export type ColumnId =
  | 'Checkbox'
  | 'Applicant'
  | 'Type'
  | 'Location'
  | 'Experience'
  | 'TotalWorkspaces'
  | 'ContactOwner'
  | 'Status'
  | 'Action'

export type SearchableApplicantSortField = 'ApplicantId' | 'Location' | 'Status'

export interface ApplicantManagementColumnDetails {
  id: ColumnId
  header: string
  align: 'left' | 'center' | 'right'
  select: boolean
  sortable: boolean
  field?: SearchableApplicantSortField
}

export const ApplicantManagementTableColumns: ApplicantManagementColumnDetails[] =
  [
    {
      id: 'Checkbox',
      header: '',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'Applicant',
      header: 'Applicant',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'Type',
      header: 'Type',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'Location',
      header: 'Location',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'Experience',
      header: 'Experience',
      select: false,
      align: 'center',
      sortable: false,
    },
    {
      id: 'TotalWorkspaces',
      header: 'Total workspaces',
      select: false,
      align: 'center',
      sortable: false,
    },
    {
      id: 'ContactOwner',
      header: 'Contact owner',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'Status',
      header: 'Status',
      select: false,
      align: 'center',
      sortable: false,
    },
    {
      id: 'Action',
      header: '',
      select: false,
      align: 'right',
      sortable: false,
    },
  ]
